import * as yup from 'yup';
import { schema as createSchema } from '../create/validation';

export const schema = createSchema.pick(['sessionDate', 'testTakerAdmissionTimeMinutes']);

export type EditSpeakingSessionFormValues = yup.InferType<typeof schema>;
